var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcCloseRegular = function SvgIcCloseRegular(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M19.636 4.363a.9.9 0 0 1 0 1.273l-14 14a.9.9 0 1 1-1.273-1.273l14-14a.9.9 0 0 1 1.273 0",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M4.363 4.363a.9.9 0 0 1 1.273 0l14 14a.9.9 0 1 1-1.273 1.273l-14-14a.9.9 0 0 1 0-1.273",
    clipRule: "evenodd"
  })));
};
export default SvgIcCloseRegular;